export enum ChatMessages {
    AGENT_JOINED = "Agent joined",
    AGENT_LEFT="Agent left"
}